/* eslint-disable @typescript-eslint/no-magic-numbers */
import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { CheckboxButtonBar } from './CheckboxButtonBar';

const onClickSpy = jest.fn();

const MOCK_CHECKBOXES = [
  {
    label: '1.1',
    value: '1',
  },
  {
    label: '1.2',
    value: '2',
  },
  {
    label: '1.3',
    value: '3',
  },
];

describe('CheckboxButton', () => {
  it('should render', () => {
    render(
      <CheckboxButtonBar
        label="Periode"
        checkboxes={MOCK_CHECKBOXES}
        defaultValues={['1', '2']}
        labelPosition="top"
        onSetValues={onClickSpy}
      />
    );
    expect(screen.getByText('Periode')).toBeInTheDocument();
    const checkbox = screen.getAllByRole('checkbox');
    expect(checkbox).toHaveLength(3);
  });

  it('should render required', () => {
    render(
      <CheckboxButtonBar
        label="Periode"
        required={true}
        checkboxes={MOCK_CHECKBOXES}
        defaultValues={['1', '2']}
        labelPosition="top"
        onSetValues={onClickSpy}
      />
    );
    const label = screen.getByText('Periode');
    expect(label).toHaveTextContent('Periode');
    expect(label).toHaveClass('label--required');
    const checkbox = screen.getAllByRole('checkbox');
    expect(checkbox).toHaveLength(3);
  });

  it('should render default checked', () => {
    render(
      <CheckboxButtonBar
        label="Periode"
        checkboxes={MOCK_CHECKBOXES}
        defaultValues={['1', '2']}
        labelPosition="top"
        onSetValues={onClickSpy}
      />
    );
    const label = screen.getByText('Periode');
    expect(label).toHaveTextContent('Periode');
    const checkbox = screen.getAllByRole('checkbox');
    expect(checkbox).toHaveLength(3);
    expect(checkbox[0]).toBeChecked();
    expect(checkbox[1]).toBeChecked();
    expect(checkbox[2]).not.toBeChecked();
  });

  it('should render notValidatedText and notValid style', () => {
    render(
      <CheckboxButtonBar
        label="Periode"
        notValidatedText="Not Valid"
        checkboxes={MOCK_CHECKBOXES}
        defaultValues={['1', '2']}
        labelPosition="top"
        onSetValues={onClickSpy}
      />
    );
    const label = screen.getByText('Periode');
    expect(label).toHaveTextContent('Periode');
    expect(screen.getByText('Not Valid')).toBeInTheDocument();
    const checkbox = screen.getAllByRole('checkbox');
    expect(checkbox).toHaveLength(3);
    expect(screen.getByText('1.1')).toHaveClass('checkbox-button--not-valid');
    expect(screen.getByText('1.2')).toHaveClass('checkbox-button--not-valid');
    expect(screen.getByText('1.3')).toHaveClass('checkbox-button--not-valid');
  });
});
